import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import WarningIcon from '@mui/icons-material/Warning';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '@ui-elements/Button';
import { isAdminPath } from '@functional';
import { ROUTES } from '~/constants/routes';
import { PALETTE, TYPOGRAPHY, FONT_WEIGHTS } from '~/assets/styles/base';

const StyledBox = styled.div`
  background: ${PALETTE.white};
  width: 806px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 211px auto;
  padding: 51px 20px 59px 50px;
  text-align: center;
  white-space: pre-line;
  a {
    text-decoration: none;
  }
`;

const FlexStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledWarningImg = styled(WarningIcon)`
  color: ${PALETTE.error.main};
  font-size: 125px;
  margin: 0 60px 0 40px;
`;

const StyledTextWrapper = styled.div`
  text-align: left;
`;

const BtnWrapper = styled.div`
  margin-left: 250px;
  button {
    font-weight: ${FONT_WEIGHTS.base};
  }
`;

interface VariousErrorProps {
  errorPageNum: string;
}

const VariousError: React.FC<VariousErrorProps> = ({ errorPageNum }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectUrl = isAdminPath() ? ROUTES.ADMIN.MYPAGE : ROUTES.USER.MYPAGE;

  const handleClick = () => {
    navigate(redirectUrl);
  };

  return (
    <StyledBox>
      <FlexStyle>
        <StyledWarningImg />
        <StyledTextWrapper>
          <Typography sx={{ fontSize: '24px' }} data-testid="PagesErrorTitle">
            {t('error.title')}
          </Typography>
          <br />
          <Typography sx={{ fontSize: TYPOGRAPHY.bodyDefault }} data-testid="PagesErrorMessage">
            {t(`error.${errorPageNum}.message`)}
          </Typography>
        </StyledTextWrapper>
        <BtnWrapper>
          <Button
            color="secondary"
            colorType="navy"
            variant="outlined"
            handleClick={handleClick}
            size="small"
            data-testid="HomeButton"
          >
            {t('appCommon.backToHome')}
          </Button>
        </BtnWrapper>
      </FlexStyle>
    </StyledBox>
  );
};

VariousError.propTypes = {
  errorPageNum: PropTypes.string.isRequired,
};

export default VariousError;
